import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataservicefavorisService {

  private _data:string;
  data$ = new Subject<any>();

  set data(data:any){
    this._data = data;
    this.data$.next(data);
  }

  get date() {
    return this._data;
  }
}
